module.exports = __webpack_public_path__ + "media/images/emblems/Port-Valais_Coat_of_Arms-e03c979d8eeed1ccc305e9e6214b84dd.svg";